import React, { useCallback, useMemo } from 'react';
import { handleMessage } from '../../../../utils/handleMessage';
import { useParameter, useToast } from '../../../../hooks';
import { Container, Count, NumericOperator } from './styles';

type Props = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    handleMinus: () => void;
    handlePlus: () => void;
    amount: number;
};

const PlusMinusAmount: React.FC<Props> = ({ id, handleMinus, handlePlus, amount }) => {
    const { showToast } = useToast();
    const { parameters } = useParameter();

    const limitAmount = useMemo((): number => {
        if (!parameters)
            return -1;

        return parameters['RECIPIENT_LIMIT_AMOUNT'];
    }, [parameters]);

    const isLimitReached = useMemo((): boolean =>
        limitAmount !== -1 && limitAmount <= amount, [limitAmount, amount]);

    const validateHandlePlus = useCallback(() => {
        if (isLimitReached) {
            showToast({
                message: handleMessage('O limite é de {0} ingressos por destinatário.', [limitAmount > 0 ? limitAmount : 0]),
                type: 'error'
            });
        } else {
            handlePlus();
        }
    }, [showToast, handlePlus, isLimitReached, limitAmount]);

    return (
        <Container>
            <NumericOperator
                id={`${id}.minusbutton`}
                $disabled={amount < 2}
                onClick={handleMinus}
            >
                -
            </NumericOperator>
            <Count>{amount}</Count>
            <NumericOperator
                id={`${id}.plusbutton`}
                $disabled={isLimitReached}
                onClick={validateHandlePlus}
            >
                +
            </NumericOperator>
        </Container>
    );
};

export { PlusMinusAmount };
